import React, { useEffect, useState } from 'react'
import { Box, VStack, Skeleton, HStack, Icon, Text } from '@chakra-ui/react'
import { AiFillFolderOpen } from 'react-icons/ai'
import { GA_CATEGORY_REPOSITORY, sectionDetailedTrack } from '../repo.utils'
export const RepositoryList = ({
  repoList,
  onSelect,
  isLoading,
  selectedRepo,
}) => {
  const onSelectRepository = repository => {
    onSelect(repository)
  }
  return (
    <VStack spacing={2}>
      {isLoading
        ? [1, 2, 3, 4].map(() => {
            return <Skeleton key={Math.random() * Date.now()} />
          })
        : repoList
            .filter(doc => !!doc.activity_type_name)
            .map((repository, index) => {
              const isSelected =
                selectedRepo &&
                selectedRepo.activity_type_id === repository.activity_type_id
                  ? true
                  : false

              return (
                <HStack
                  key={repository.activity_type_id}
                  alignItems="center"
                  justifyContent="center"
                  cursor="pointer"
                  m={2}
                  borderRadius="md"
                  boxShadow="md"
                  w="full"
                  p={2}
                  onClick={() => {
                    sectionDetailedTrack({
                      category: GA_CATEGORY_REPOSITORY,
                      action: 'Repository List',
                      label: 'Select Repository',
                    })
                    onSelectRepository(repository)
                  }}
                >
                  <VStack justifyContent="center">
                    <Box
                      rounded="md"
                      size="md"
                      color="green.400"
                      bg="secondary"
                      p={2}
                    >
                      <Icon as={AiFillFolderOpen} h={6} w={6} />
                    </Box>
                  </VStack>
                  <VStack
                    alignItems="flex-start"
                    justifyContent="space-around"
                    w="full"
                  >
                    <Text fontWeight={500} my={0} fontSize="md">
                      {repository.activity_type_name}
                    </Text>
                  </VStack>
                </HStack>
              )
            })}
    </VStack>
  )
}
export default RepositoryList
